import type { Configuration, RedirectRequest } from '@azure/msal-browser'

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env['VITE_MSAL_CLIENT_ID'] as string,
    authority: import.meta.env['VITE_MSAL_AUTHORITY'] as string,
    redirectUri: import.meta.env['VITE_MSAL_REDIRECT_URI'] as string,
    postLogoutRedirectUri: '/login',
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return
        if (import.meta.env.DEV) console.debug(`[MSAL][${level}] ${message}`)
      },
    },
  },
}

export const loginRequest: RedirectRequest = {
  scopes: ['openid', 'profile', 'email', 'User.Read'],
}

export const tokenRequest = {
  scopes: ['User.Read'],
}